import { createClient } from 'next-sanity'
import imageUrlBuilder from '@sanity/image-url'
import { tryGetFile } from '@sanity/asset-utils'
import { File, ImageUrlBuilder } from 'sanity'

const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID!
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET!
const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2023-05-03'!

export const client = createClient({
    projectId,
    dataset,
    apiVersion,
    useCdn: false,
    perspective: 'published',
})

const builder = imageUrlBuilder(client)

export const getImageUrl = (source: File): ImageUrlBuilder => {
    return builder.image(source)
}

export const getFileUrl = (source: File): string | null => {
    if (!source || !source.asset || !source.asset._ref) {
        return null
    }

    try {
        const { asset } = tryGetFile(source.asset._ref, {
            projectId,
            dataset,
        }) || { asset: null }

        if (asset) {
            return asset.url
        }
        return null
    } catch {
        return null
    }
}
